import {IParticularColor} from '@toolify/server/src/services/ColorService/types/IParticularColor'
import {MaxPaletteColorCount} from '@toolify/server/src/services/ColorService/constants/MaxPaletteColorCount'
import {ParticularColorType} from '@toolify/server/src/services/ColorService/enum/ParticularColorType'

export function getParticularColorBySeed(seed: string): IParticularColor {
  if([null, undefined].includes(seed)) {
    return {
      colorType: ParticularColorType.Palette,
      payload: 14,
    }
  }
  const seedAsNumber = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
  const payload = seedAsNumber % MaxPaletteColorCount
  return {
    colorType: ParticularColorType.Palette,
    payload,
  }
}
